import { render } from "./AboutUsTeam.vue?vue&type=template&id=43d8fa35&lang=pug"
import script from "./AboutUsTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUsTeam.vue?vue&type=script&setup=true&lang=js"

import "./AboutUsTeam.vue?vue&type=style&index=0&id=43d8fa35&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__